import { Injectable } from '@angular/core';
import { RaintreeResponse } from '../interfaces/raintree-response';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import {
  KeywordSearchRequest,
  KeywordSearchRespo,
  SerialStatusResponse,
} from '../interfaces/keyword-search';

@Injectable({
  providedIn: 'root',
})
export class KeywordSearchService extends ApiService {
  public getSearchData(
    payLoad: KeywordSearchRequest
  ): Observable<KeywordSearchRespo> {
    return this.post<KeywordSearchRespo>(ROUTES.KEYWORD_SEARCH, {
      body: payLoad,
    });
  }
  public getSlDetails(
    slNo: any,
    payLoad: any
  ): Observable<SerialStatusResponse> {
    return this.get<SerialStatusResponse>(
      this.replacePathInfo(ROUTES.GLOBAL_SEARCH_SL_DETAILS, {
        memKey: slNo,
      }),
      {
        params: payLoad,
      }
    );
  }
}
